import { ButtonHTMLAttributes, cloneElement, isValidElement, MouseEventHandler, ReactElement } from 'react';
import { useItineraryMapStore } from "@/core/stores/itinerary";
import { useItineraryStoreV2 } from '@/core/stores/itinerary/itineraryV2';
import { ItineraryV2UserRoles } from '@/types/itinerary/itineraryV2';



interface AccessControllerProps {
  allowedRoles: ItineraryV2UserRoles[];
  children: ReactElement<ButtonHTMLAttributes<HTMLButtonElement>, 'button'>;
}

const AccessController = ({ allowedRoles, children }: AccessControllerProps) => {
  const { itineraryUser } = useItineraryStoreV2();
  const { setShowAccessModal } = useItineraryMapStore();
  const userRole = itineraryUser?.role;
  const hasAccess = userRole && allowedRoles.includes(userRole);

  if (!hasAccess && isValidElement(children)) {
    const handleClick: MouseEventHandler<HTMLButtonElement> = (e) => {
      e.preventDefault();
      e.stopPropagation();
      setShowAccessModal?.(true);
    };

    return cloneElement(children, {
      style: {
        ...children.props.style,
        opacity: 0.5,
        cursor: 'not-allowed',
      },
      onClick: handleClick,
      onChange: handleClick,
    });
  }

  return children;
};

export default AccessController;
